<div class="popup">
  <form (ngSubmit)="onSubmitSpecification()" aria-labelledby="title">
    <h1 i18n="@@AddToSpecification">Добавить в спецификацию</h1>
    <div class="form-content">

      @if (cartSpecifications.length) {
        <div>
          <div class="form-control-group">
            <p>
              <input nbInput fieldSize="small" fullWidth type="text" placeholder="Поиск" name="keyword" [(ngModel)]="keyword" (keyup)="onKey($event)">
            </p>
            @if (cartSpecificationsFiltered.length) {
              <nb-card>
                <div class="popup-table">
                  @for (item of cartSpecificationsFiltered; track item) {
                    <div class="form-control__item">
                      <nb-checkbox (checkedChange)="toggle($event, item.id)">{{ item.header }}</nb-checkbox>
                    </div>
                  }
                </div>
              </nb-card>
            }
            <nb-card-footer>
              <button nbButton status="primary"
                size="large"
                type="submit"
                i18n="@Add"
                [nbSpinner]="submitted" nbSpinnerStatus="control" [disabled]="!hasSelected() || submitted">
              Добавить
            </button>
            </nb-card-footer>
          </div>
        </div>
      }
    </div>
  </form>
</div>
